export const SUPPORTS_OBJECT_GET_OWN_PROPERTY_SYMBOLS = "getOwnPropertySymbols" in Object;
